function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 35 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5779,-697)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4341.5,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tick",
    transform: "matrix(1,0,0,1.03814,-186.946,180.525)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.384528,0,0,0.384631,1098.08,165.604)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1414.54,
    cy: 907.398,
    r: 44.397,
    style: {
      fill: "rgb(57,123,15)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.89328,0,0,0.863732,-7753.89,-2419.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10509.7,3399.17L10514.8,3404.31L10527.1,3390.29",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "3.49px"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.a52c54466679f7d664621c81557a6eab.svg";
export { ForwardRef as ReactComponent };